module.exports = __webpack_public_path__ + "img/expertise_split.d078af91.png";